import { Component, Input, OnInit } from '@angular/core';
import { defaultHours, WorkingHours, WorkingHoursRange } from '../../lead-generation/shared/domain/WorkingHours';
import { FormGroupWrapper } from '../../lead-generation/shared/domain/FormGroupWrapper';
import { FormArray, FormBuilder } from '@angular/forms';
import { createGroup, createRange } from './workingHoursFormCreator';
import { Configuration } from '../../lead-generation/shared/domain/configuration.model';

@Component({
  selector: 'cc-lg-working-hours-list',
  templateUrl: './working-hours-list.component.html',
  styleUrls: ['./working-hours-list.component.scss']
})
export class WorkingHoursListComponent implements OnInit {
  @Input() workingHoursFormWrapper: FormGroupWrapper;
  @Input() configuration: Configuration;
  @Input() displayTitle: string;

  disabledDays: number[];

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.disabledDays = this.work.ranges.reduce((disabled, range) => [...disabled, ...range.days], []);

    this.workingHoursFormWrapper.form = createGroup(this.work, this.work.timezone, this.fb);
  }

  onSelectionChanged(day) {
    const isAlreadyDisabled = this.disabledDays.includes(day);

    if (isAlreadyDisabled) {
      this.disabledDays = this.disabledDays.filter(d => d !== day);
    } else {
      this.disabledDays = [day, ...this.disabledDays];
    }
  }

  get work(): WorkingHours {
    return this.configuration.workingHours;
  }

  get form() {
    return this.workingHoursFormWrapper.form;
  }

  get ranges(): FormArray {
    return this.form.controls['ranges'] as FormArray;
  }

  deleteRange(index: number) {
    const days = [...this.ranges.at(index).get('days').value];
    this.ranges.removeAt(index);
    this.disabledDays = this.disabledDays.filter(day => !days.includes(day));
  }

  get workingHoursAreEnabled() {
    return this.form.get('enabled').value;
  }

  get allDaysAreDisabled() {
    return this.disabledDays.length === 7;
  }

  createNewRange() {
    const newRange: WorkingHoursRange = { hours: [defaultHours], days: [] };
    this.ranges.push(createRange(newRange, this.fb));
  }
}
